import Configuration from "@/managers/system/configuration"

export function reloadIfNotOnCooldown(key: string): boolean {
	let lastReload = 0
	const raw = sessionStorage.getItem(key)

	if (raw !== null) {
		lastReload = parseInt(raw, 10)

		if (isNaN(lastReload))
			lastReload = 0
	}

	const now = Date.now()

	if (lastReload > now) { // System time must have changed
		clearExpiredCooldown(key)
		return false
	}

	if (lastReload + Configuration.system.reloadCooldown > now)
		return false

	sessionStorage.setItem(key, now.toString(10))
	window.location.reload()
	return true
}

export function clearExpiredCooldown(key: string): void {
	const raw = sessionStorage.getItem(key)

	if (raw === null)
		return

	const lastReload = parseInt(raw, 10)
	const now = Date.now()

	if (isNaN(lastReload) || lastReload <= now - Configuration.system.reloadCooldown)
		sessionStorage.removeItem(key)
}
